import { HttpClient, HttpContext } from '@angular/common/http'
import { Injectable } from '@angular/core'
import {
  ERROR_INTERCEPTOR_BYPASS,
  HELIOS_COMMAND_HTTP_TOKEN,
} from '@helios/utils'
import { Observable } from 'rxjs'
import {
  TransactionActionRequest,
  TransactionsActionResponse,
} from '../../models/commands.model'
import {
  CashBreakSuggestion,
  CashResolveRequest,
  CommandCreationResponse,
} from './../../models/copilot.model'

@Injectable({
  providedIn: 'root',
})
export class HttpCopilotService {
  constructor(private readonly http: HttpClient) {}
  COPILOT = `helios-copilot`
  BREAKS = 'helios-breaks'
  ACTIONS_URL = 'helios-cw-transactions/actions'

  submitCashBreakSuggestion(cashBreakSuggestion: CashBreakSuggestion) {
    const SOLUTION_URL = `${this.COPILOT}/cashBreak/solution`

    return this.http
      .post<CommandCreationResponse[]>(`${SOLUTION_URL}`, cashBreakSuggestion, {
        context: new HttpContext().set(ERROR_INTERCEPTOR_BYPASS, [400]),
      })
      .toPromise()
  }

  getCashBreakSuggestions(
    request: CashResolveRequest,
  ): Promise<CashBreakSuggestion[]> {
    return this.http
      .post<CashBreakSuggestion[]>(`${this.BREAKS}/cash-resolve`, request, {
        context: new HttpContext().set(ERROR_INTERCEPTOR_BYPASS, [400]),
      })
      .toPromise()
  }

  createCommands(
    transactionActionRequest: TransactionActionRequest,
  ): Observable<TransactionsActionResponse> {
    return this.http.post<TransactionsActionResponse>(
      this.ACTIONS_URL,
      transactionActionRequest,
      {
        headers: {
          'helios-internal-cmd-panel': 'Clearwater Transactions',
          'helios-internal-cmd-action': transactionActionRequest.actionType,
        },
        context: new HttpContext().set(HELIOS_COMMAND_HTTP_TOKEN, true),
      },
    )
  }
}
